export default {
  commonObj: state => state.commonObj,
  orgList: state => state.commonObj.organizationProfileList
}
